import { couponStatusArr, grantObj, promotionTypes, goodsBelongLabels, usedTypes } from 'json/mall-options'
import { cashCount } from '@/utils/formUtils'
export let typeTabs = [{
  label: '优惠劵',
  value: 'coupon'
},
{
  label: '促销活动',
  value: 'promotion'
}
]
// 优惠劵状态
export let couponStatus = couponStatusArr
// 折扣类型
export let discountTypes = [{
  label: '固定额度',
  value: 'FIXED_AMOUNT',
  border: true
},
{
  label: '比率折扣',
  value: 'PROPORTION',
  border: true
}
]
// 选择商品的列表顶部筛选
export let couponGoodsLabs = [{
  label: '商品名称',
  type: 'input',
  clearable: true,
  value: 'name' // 需返回数据的字段名
},
{
  label: '分类',
  type: 'select',
  clearable: true,
  value: 'type', // 需返回数据的字段名
  options: []
}
]
// 优惠劵发布方式
// export let publishTypeLabels = publishType
export let publishTypeLabels = [{
  label: '发放',
  value: 'GRANT'
},
{
  label: '领取',
  value: 'RECEIVE'
},
//   {
//     label: '下载优惠劵',
//     value: 'QR_CODE'
//   },
{
  label: '积分优惠券',
  value: 'BY_POINTS'
},
{
  label: '活动赠券',
  value: 'BY_OTHER_PROMOTION'
},
{
  label: '邀新赠券(每邀请一个新用户，邀请人获得一张)',
  value: 'INVITE_NEW_USER_REWARD'
},
{
  label: '邀请家人注册成功奖励',
  value: 'INVITE_FAMILY_REWARD'
}
]
// 优惠劵发布对象
export let publishObj = grantObj
export let publishOfflineObj = [{
  label: '指定用户',
  value: 'DESIGNATED_USER'
},
{
  label: '邀新奖励',
  value: 'MEET_CONDITIONS_USER'
}
]
// 促销活动列表labels
export let promotionTableLabels = [{
  label: '活动类型',
  value: 'promotionType'
},
{
  label: '状态',
  value: 'promotionStatus'
}
]
// 促销活动类型
export let promotionType = promotionTypes
// 新建/编辑促销活动时，选择优惠劵的顶部tab
export let couponNameTabs = [{
  label: '优惠劵名称',
  value: 'name',
  clearable: true,
  type: 'input'
}]
// 新建/编辑促销活动，添加优惠劵的表格-labels
export let couponForPromotionLabels = [
  //   {
  //     label: '发放总量',
  //     value: 'amount'
  //   },
  //   {
  //     label: '适用商品',
  //     value: ''
  //   },
  {
    label: '有效期',
    minWidth: 160,
    value: 'validity_date'
  },
  {
    label: '状态',
    value: 'coupon_status'
  }
]
// 常用用户筛选条件
export let screenUser = [{
  label: '全部用户',
  value: 'ALL'
},
{
  label: '全部男性用户',
  value: 'MALE'
},
{
  label: '全部女性用户',
  value: 'FEMALE'
},
{
  label: '全部CPS绑定用户',
  value: 'bindCps'
},
{
  label: '全部非CPS绑定用户',
  value: 'bindCpsFalse'
}
]
export let goodsBelongLabel = [{
  label: '全部商品',
  value: 'ALL'
},
...goodsBelongLabels
]
export let usedType = usedTypes
export let usedRegion = [{
  label: '全国通用',
  value: true
},
{
  label: '选择地区',
  value: false
}
]
export let fullReductionTypes = [{
  label: '按购买数量',
  value: 'COUNT'
},
{
  label: '按购买金额',
  value: 'MONEY'
}
]
export function getGoodsBelongLabel (val) {
  let label
  goodsBelongLabel.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 当优惠券不限商品时，格式化"全部XX商品"字样
export function formatAllGoodsBelong (val) {
  let label = getGoodsBelongLabel(val)
  if (!label) {
    return label
  }
  if (label.indexOf('全部') >= 0) {
    return label
  } else {
    return '全部' + label
  }
}
// 将多规格商品拆分
export function specificationsData (val, old) {
  let goodsList = []
  let hasOld = false
  val.forEach(item => {
    let specifications = (item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.specifications && item.goodsDTO.goodsData.specifications[0] && item.goodsDTO.goodsData.specifications[0].items) || null
    let goodsData = (item.goodsDTO && item.goodsDTO.goodsData) || {}
    if (specifications && specifications.length > 0) {
      specifications.forEach(etem => {
        let isSpe = false
        etem.goodsId = item.goodsDTO.id
        let goodsItem = JSON.parse(JSON.stringify(item))
        goodsItem.final_price = etem.price && ('¥' + cashCount(etem.price, true))
        goodsItem.final_price_no_sign = etem.price && cashCount(etem.price, true, 2)
        // 判断是否有订金+尾款支付方式
        if (goodsData.paymentModes && goodsData.paymentModes.length && goodsData.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1) {
          goodsItem.deposit_no_sign = etem.deposit && cashCount(etem.deposit, true, 2)
          goodsItem.balance_no_sign = etem.balance && cashCount(etem.balance, true, 2)
        }
        goodsItem.goodsOtherInfoDTO.stockQuantity = etem.stockQuantity
        goodsItem.discount_show = null
        if (item.discountGoodsData) {
          item.discountGoodsData.forEach(atem => {
            if (atem.specificationId === etem.itemId) {
              isSpe = true
              goodsListData(goodsItem, atem)
            }
          })
        } else {
          isSpe = true
        }
        if (old && old.length) {
          hasOld = true
          old.forEach(dtem => {
            let discountGoodsData = dtem.discountGoodsData || null
            if (discountGoodsData) {
              discountGoodsData.forEach(ftem => {
                if (ftem.specificationId === etem.itemId) {
                  //   goodsListData(goodsItem, ftem)
                }
              })
            } else {
              //   console.log('dtem.goodsDTO', dtem.goodsDTO)
              if (dtem.goodsDTO.id === item.goodsDTO.id) {
                let oldSpe = (dtem.goodsDTO && dtem.goodsDTO.goodsData && dtem.goodsDTO.goodsData.specifications && dtem.goodsDTO.goodsData.specifications[0] && dtem.goodsDTO.goodsData.specifications[0].items) || null
                if (oldSpe) {
                  oldSpe.forEach(tem => {
                    if (tem.itemId === etem.itemId) {
                      goodsListData(goodsItem, tem)
                    }
                  })
                }
              }
            }
          })
        }
        goodsItem.paymentModes = goodsData.paymentModes
        if (isSpe || hasOld) {
          goodsList.push({ ...goodsItem, specifications: etem })
        }
      })
    } else {
      let goodsItem = JSON.parse(JSON.stringify(item))
      let goodsData = (goodsItem.goodsDTO && goodsItem.goodsDTO.goodsData) || {}
      console.log('goodsItem', goodsItem)
      if (item.discountGoodsData && item.discountGoodsData[0]) {
        let discountGoodsData = item.discountGoodsData[0]
        goodsListData(goodsItem, discountGoodsData)
      }
      goodsItem.final_price_no_sign = goodsData.finalPrice && cashCount(goodsData.finalPrice, true, 2)
      goodsItem.paymentModes = goodsData.paymentModes
      // 判断无规格商品订金/尾款
      if (goodsData.paymentModes && goodsData.paymentModes.length && goodsData.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1) {
        goodsItem.deposit_no_sign = goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true, 2)
        goodsItem.balance_no_sign = goodsData.noSpecificationsBalance && cashCount(goodsData.noSpecificationsBalance, true, 2)
      }
      goodsList.push({ ...goodsItem, specifications: { goodsId: goodsItem.goodsDTO.id, name: '默认规格' } })
    }
  })
  return goodsList
}
export function goodsListData (goodsItem, atem) {
  goodsItem.discount_show = (atem.discount && cashCount(atem.discount, true)) || null
  goodsItem.discount_discount_show = atem.discount && atem.price && (atem.discount * 10 / atem.price).toFixed(1)
  goodsItem.amount = atem.amount
  goodsItem.snapUp_price = atem.snapUpPrice && cashCount(atem.snapUpPrice, true)
  goodsItem.promotional_price = atem.promotionalPrice && cashCount(atem.promotionalPrice, true)
  goodsItem.useFullReduction = atem.useFullReduction
  goodsItem.cash_price = atem.price && cashCount(atem.price, true)
  goodsItem.buyer_cashBack = (atem.buyerCashBack && cashCount(atem.buyerCashBack, true, 2)) || null
  goodsItem.sharer_cashBack = (atem.sharerCashBack && cashCount(atem.sharerCashBack, true, 2)) || null
  goodsItem.buyerCouponsBack = atem.buyerCouponsBack
  goodsItem.sharerCouponsBack = atem.sharerCouponsBack
  goodsItem.bringNewReward = atem.bringNewReward
  goodsItem.buyerTicketsReward = atem.buyerTicketsReward
  goodsItem.sharerTicketsReward = atem.sharerTicketsReward
  goodsItem.actId = atem.actId
  goodsItem.actTicketsName = atem.actTicketsName
}
